import React, { useState } from "react";
import { Sparkles, RotateCcw, Volume2, VolumeX } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "./ui/alert-dialog";

export default function Header({ onReset, muted, onToggleMute }) {
  const [open, setOpen] = useState(false);
  return (
    <header className="border-b border-white/10 bg-black/40 backdrop-blur-md sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="relative h-7 w-7 border border-purple-400/60 flex items-center justify-center">
            <Sparkles className="h-3.5 w-3.5 text-purple-300 animate-flicker" />
            <div className="absolute -inset-px bg-purple-500/10 blur-md -z-10" />
          </div>
          <div>
            <div className="font-display font-black uppercase tracking-tight text-sm md:text-base text-white">
              The System
            </div>
            <div className="text-[9px] uppercase tracking-[0.3em] text-slate-500 -mt-0.5">
              Hunter Protocol · v1
            </div>
          </div>
        </div>
        <div className="flex items-center gap-1.5">
          <button
            onClick={onToggleMute}
            className="p-2 border border-white/10 hover:border-blue-400/50 hover:bg-blue-500/10 transition"
            data-testid="mute-toggle"
            aria-label="Toggle sound"
          >
            {muted ? (
              <VolumeX className="h-4 w-4 text-slate-400" />
            ) : (
              <Volume2 className="h-4 w-4 text-blue-300" />
            )}
          </button>
          <AlertDialog open={open} onOpenChange={setOpen}>
            <AlertDialogTrigger asChild>
              <button
                className="p-2 border border-white/10 hover:border-red-400/50 hover:bg-red-500/10 transition"
                data-testid="reset-button"
                aria-label="Reset progress"
              >
                <RotateCcw className="h-4 w-4 text-slate-400" />
              </button>
            </AlertDialogTrigger>
            <AlertDialogContent
              className="bg-[#0A0D14] border border-red-500/40 rounded-none text-white"
              data-testid="reset-dialog"
            >
              <AlertDialogHeader>
                <AlertDialogTitle className="font-display uppercase tracking-tight text-2xl">
                  Sever the Contract?
                </AlertDialogTitle>
                <AlertDialogDescription className="text-slate-400">
                  All progress, ranks, and shadows will be wiped from The
                  System. This cannot be undone.
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel className="rounded-none bg-transparent border-white/20 hover:bg-white/5 text-slate-300">
                  Cancel
                </AlertDialogCancel>
                <AlertDialogAction
                  onClick={onReset}
                  className="rounded-none bg-red-600 hover:bg-red-500"
                  data-testid="reset-confirm"
                >
                  Wipe Progress
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </div>
      </div>
    </header>
  );
}
